import moment from "moment";
import { parsePhoneNumberFromString } from "libphonenumber-js";

export const formatReservationTime = (value) => {
    if (!value) return "";
    return moment(String(value)).format("hh:mm A");
};

export const formatReservationDate = (value) => {
    if (!value) return "";
    return moment(String(value)).format("MM/DD/YYYY");
};

export const getCarLocation = (reservation) => {
    const car = reservation?.carSelected;
    if (car?.baseLocation) return car.baseLocation;
    if (car?.location?.city && car?.location?.state) return `${car.location.city}, ${car.location.state}`;
    if (car?.location?.address) return car.location.address;
    return null;
};

export const formatReservationPhone = (mobileNumber) => {
    if (!mobileNumber) return "";
    const raw = String(mobileNumber).trim();
    const international = parsePhoneNumberFromString(raw.startsWith("+") ? raw : `+${raw}`);
    if (international?.isValid()) return international.formatNational();
    const domestic = parsePhoneNumberFromString(raw, "US");
    return domestic?.isValid() ? domestic.formatNational() : raw;
};
